export default __webpack_public_path__ + "d3f00e146306b0b5ab873eb4545b72bf.svg";